import { watch } from 'vue';
import { useAccount } from './useAccount';

function updateFavicons(branding) {
  const updates = {
    '.favicon': branding.favicon_96,
    'link[rel="apple-touch-icon"][sizes="180x180"]': branding.apple_touch_icon,
    'link[rel="icon"][sizes="192x192"]': branding.android_icon,
    'link[rel="icon"][sizes="512x512"]': branding.logo_thumbnail,
  };

  Object.entries(updates).forEach(([selector, url]) => {
    if (!url) return;
    document.querySelectorAll(selector).forEach(el => {
      el.href = url;
    });
  });
}

function updateTitle(branding) {
  if (branding.installation_name) {
    document.title = branding.installation_name;
  }
}

export function useDynamicBranding() {
  const { currentAccount, accountBranding } = useAccount();

  watch(
    [currentAccount, accountBranding],
    ([account, branding]) => {
      if (!account || !branding) return;

      if (branding.favicon_96 || branding.apple_touch_icon) {
        updateFavicons(branding);
      }
      updateTitle(branding);
    },
    { immediate: true }
  );

  return { accountBranding };
}
